  // src/assets/data/arrays.js
export const tiposDeDocumento = [
    { value: "13", label: "Cédula de ciudadanía" },
    { value: "22", label: "Cédula de extranjería" },
    { value: "31", label: "NIT" },
    { value: "41", label: "Pasaporte" },
    { value: "47", label: "Permiso Especial de Permanencia" },
    { value: "11", label: "Registro civil de nacimiento" },
    { value: "12", label: "Tarjeta de identidad" },
    { value: "21", label: "Tarjeta de extranjería" },
    { value: "42", label: "Tipo de documento extranjero" }
    ];
    
    export const tipoLead = [
      { value: "Chat", label: "Chat" },
      { value: "Mercado Libre", label: "Mercado Libre" },
      { value: "Rappi", label: "Rappi" },
      { value: "Sitio Web", label: "Sitio Web" },
      { value: "Teléfono", label: "Teléfono" }
    ];
    
    export const tipoCliente = [
      { value: "B2B", label: "B2B" },
      { value: "B2C", label: "B2C" }
    ];
    
    export const tipoServicio = [
      { value: "5", label: "Cadenade Frio" },
      { value: "1", label: "Documento Express" },
      { value: "7", label: "Envía Internacional" },
      { value: "2", label: "Mercancia Aerea" },
      { value: "3", label: "Mercancia Terrestre" },
      { value: "13", label: "Paquete Aereo" },
      { value: "12", label: "Paquete Terrestre" },
      { value: "4", label: "Radicacion Factura" },
      { value: "10", label: "Semi masivo" }
      ];
    
    export const formaPago =[
        { value: "6", label: "Contado" },
        { value: "7", label: "Contra entrega" },
        { value: "4", label: "Crédito" },
      ];

    /** Códigos de forma de pago que envía Ofima en el documento. */
    export const formaPagoOfima = [
      { value: 'cont', label: 'Contado' },
      { value: 'cred', label: 'Crédito' }
    ]

    export const conocer =[
      { value: "Google", label: "Google" },
      { value: "Influencer", label: "Influencer" },
      { value: "Linkedin", label: "Linkedin" },
      { value: "Recompra", label: "Recompra" },
      { value: "Redes Sociales", label: "Redes Sociales" },
      { value: "Referido", label: "Referido" },
    ];

    export const banco =[
      { value: "Addi", label: "Addi" },
      { value: "BANCO AV Villas", label: "Banco AV Villas" },
      { value: "BANCO CREDIFINANCIERA", label: "BANCO CREDIFINANCIERA" },
      { value: "BANCO DE LAS MICROFINANZAS BANCAMIA", label: "BANCO DE LAS MICROFINANZAS BANCAMIA" },
      { value: "BANCO SANTANDER COLOMBIA", label: "BANCO SANTANDER COLOMBIA" },
      { value: "BANCO SERFINANZA", label: "BANCO SERFINANZA" },
      { value: "Banco Agrario", label: "Banco Agrario" },
      { value: "Banco BBVA Colombia S.A.", label: "Banco BBVA Colombia S.A." },
      { value: "Banco Caja Social", label: "Banco Caja Social" },
      { value: "Banco Cooperativo Coopcentral", label: "Banco Cooperativo Coopcentral" },
      { value: "Banco Davivienda", label: "Banco Davivienda" },
      { value: "Banco De Bogota", label: "Banco De Bogota" },
      { value: "Banco De Occidente", label: "Banco De Occidente" },
      { value: "Banco Falabella", label: "Banco Falabella" },
      { value: "Banco GNB Sudameris", label: "Banco GNB Sudameris" },
      { value: "Banco Itaú", label: "Banco Itaú" },
      { value: "Banco Pichincha S.A.", label: "Banco Pichincha S.A." },
      { value: "Banco Popular", label: "Banco Popular" },
      { value: "Bancoomeva S.A.", label: "Bancoomeva S.A." },
      { value: "Bancolombia", label: "Bancolombia" },
      { value: "CFA COOPERATIVA FINANCIERA", label: "CFA COOPERATIVA FINANCIERA" },
      { value: "Citibank", label: "Citibank" },
      { value: "COLTEFINANCIERA", label: "COLTEFINANCIERA" },
      { value: "Confiar Cooperativa Financiera", label: "Confiar Cooperativa Financiera" },
      { value: "COTRAFA", label: "COTRAFA" },
      { value: "DaviPlata", label: "DaviPlata" },
      { value: "FINANCIERA DANN REGIONAL - IRIS", label: "FINANCIERA DANN REGIONAL - IRIS" },
      { value: "GIROS Y FINANZAS", label: "GIROS Y FINANZAS" },
      { value: "NEQUI", label: "NEQUI" },
      { value: "RAPPIPAY", label: "RAPPIPAY" },
      { value: "SCOTIABANK COLPATRIA", label: "SCOTIABANK COLPATRIA" },
      { value: "WOMPI", label: "WOMPI" }
      ];
  
    export const metodoPago =[
      { value: "cmdm", label: "Crédito MDM" },
      { value: "plan_separe", label: "Plan Separe" },
      { value: "addi", label: "Crédito ADDI" },
      { value: "dataf", label: "Datafono" },
      { value: "cash", label: "Pago en efectivo" },
      { value: "bold", label: "Pago en Línea BOLD" },
      { value: "mpago",label: "Pago en Línea MPAGO" },
      { value: "wompi", label: "Pago en Línea WOMPI" },
      { value: "part", label: "Pagos Parciales" },
      { value: "cod",  label: "Recaudo Contra Entrega" },
      { value: "bacs", label: "Transferencia bancaria Bancolombia" },
      { value: "reof", label: "Remision Ofima" },
      { value: "hpago", label: "Homedelivery" }
    ];

export const plazosPago = [
  { value: '5', label: '5 días' },
  { value: '10', label: '10 días' },
  { value: '15', label: '15 días' },
  { value: '20', label: '20 días' },
  { value: '30', label: '30 días' },
  { value: '60', label: '60 días' }
]

    export const transportadora=[
      { value: "noventa9minutos", label: "99 Minutos" },
      { value: "coordinadora", label: "Coordinadora" },
      { value: "deprisa", label: "Deprisa" },
      { value: "El_Socio", label: "El Socio" },
      { value: "envía", label: "Envía" },
      { value: "entrega_pdv", label: "Entrega PDV" },
      { value: "fulfillment", label: "FULL Mercado Libre" },
      { value: "inter_rapidisimo", label: "Inter Rapidisimo" },
      { value: "mensajero_interno", label: "Mensajero interno" },
      { value: "mensajeros_urbanos", label: "Mensajeros urbanos" },
      { value: "servientrega", label: "Servientrega" },
      { value: "tcc", label: "TCC" },
      { value: "rappi", label: "Rappi" },
      { value: "home_delivery", label: "Home Delivery" },
      { value: "meli", label: "Meli" },
      { value: "falabella", label: "Falabella" },
    ];

    /** Bodegas de facturación en pedidos (id_market / select Bodega de Facturación) */
    export const bodegaFacturacion = [
      { value: '95', label: 'Bodega Xerox' },
      { value: '93', label: 'ML Bigcenter' },
      { value: '94', label: 'ML Distrito Cafetero' },
      { value: 'ecommerce', label: 'Ecommerce' },
      { value: '97', label: 'En tránsito' },
      { value: '98', label: 'HOMECENTER' }
    ]

    /** Almacenes Flexy. Fuente única de idalmacen para cron de stock y lista de productos. */
    export const flexyAlmacenes = [
      { idalmacen: 118, codigo: 'FUL-MDM', nombre: 'FULFILLMENT', orden_pedido: 1 },
      { idalmacen: 122, codigo: 'XER-MDM', nombre: 'XEROX', orden_pedido: 2 },
      { idalmacen: 123, codigo: 'EXXE-MDM', nombre: 'EXHIBICIÓN XEROX', orden_pedido: 3 },
      { idalmacen: 116, codigo: 'ALM-MDM', nombre: 'ALMACENAMIENTO', orden_pedido: 4 },
      { idalmacen: 119, codigo: 'SAL-MDM', nombre: 'SALDOS', orden_pedido: 5 },
      { idalmacen: 121, codigo: 'RES-MDM', nombre: 'RESERVAS', orden_pedido: 6 },
      { idalmacen: 120, codigo: 'DEV-MDM', nombre: 'DEVOLUCIONES', orden_pedido: 7 },
      { idalmacen: 127, codigo: 'TRA-MDM', nombre: 'TRANSITO', orden_pedido: 8 }
    ]

    export const ORDER_STATES = [
      { value: "asignado", label: "Asignado", color: "bg-indigo-100 text-indigo-800" },
      { value: "bodega-devolucion", label: "Bodega devolucion", color: "bg-slate-300 text-slate-800" },
      { value: "cancelled", label: "Cancelado", color: "bg-red-200 text-red-900" },
      { value: "carrier_issue", label: "En novedad transportadora", color: "bg-red-100 text-red-800" },
      { value: "completed", label: "Completado", color: "bg-green-100 text-green-800" },
      { value: "eliminado", label: "Eliminado", color: "bg-red-100 text-red-800" },
      { value: "empacado", label: "Empacado", color: "bg-orange-100 text-orange-800" },
      { value: "en-devolucion", label: "En devolucion", color: "bg-red-100 text-gray-800" },
      { value: "EnReparto", label: "En Reparto", color: "bg-cyan-100 text-cyan-800" },
      { value: "enviado", label: "Enviado", color: "bg-teal-100 text-teal-800" },
      { value: "fallido", label: "Fallido", color: "bg-black-400 text-white" },
      { value: "guia-eliminada", label: "Guia Eliminada", color: "bg-red-100 text-red-800" },
      { value: "incidencia", label: "Incidencia", color: "bg-red-100 text-red-800" },
      { value: "incidencia-resuelta", label: "Incidencia resuelta", color: "bg-green-100 text-green-800" },
      { value: "on-hold", label: "En espera", color: "bg-red-100 text-red-800" },
      { value: "on_route", label: "En camino", color: "bg-cyan-100 text-cyan-800" },
      { value: "payment_failed", label: "Pago fallido", color: "bg-red-100 text-red-800" },
      { value: "pending", label: "Pendiente de pago", color: "bg-yellow-100 text-yellow-800" },
      { value: "picking_started", label: "Picking Iniciado", color: "bg-pink-100 text-pink-800" },
      { value: "por_completar", label: "Por Completar", color: "bg-amber-100 text-amber-800" },
      { value: "por_procesar", label: "Por Procesar", color: "bg-amber-200 text-amber-900" },
      { value: "processing", label: "Procesando", color: "bg-purple-100 text-purple-800" },
      { value: "por_remisionar", label: "Por Remisionar", color: "bg-emerald-300 text-black-400" },
      { value: "rma", label: "RMA", color: "bg-amber-100 text-amber-800" },
      { value: "send_later", label: "Enviar luego", color: "bg-gray-100 text-gray-800" },
      { value: "verify_transaction", label: "Verificar Transacción", color: "bg-blue-100 text-custom-blue" },
      { value: "abonado", label: "Abonado", color: "bg-emerald-100 text-emerald-900" },
      { value: "devolucion_dinero", label: "Devolución de dinero", color: "bg-green-700 text-white" },
      { value: "enpdv", label: "En PDV", color: "bg-orange-300 text-orange-950" },
      { value: "sin_stock_flexy", label: "Sin stock Flexy", color: "bg-orange-300 text-orange-950" },
      { value: "devolucion_verificada", label: "Devolución verificada", color: "bg-green-700 text-white" },
      { value: "devolucion_incompleta", label: "Devolución incompleta", color: "bg-amber-100 text-amber-900" },
      { value: "devolucion_incompleta_por_nc", label: "Devolución incompleta por NC", color: "bg-amber-200 text-amber-900" },
      { value: "devolucion_con_faltantes", label: "Devolución con faltantes", color: "bg-amber-100 text-amber-900" },
      { value: "verificar_devolucion", label: "Verificar devolución", color: "bg-green-700 text-white" },
      { value: "devolucion_por_verificar", label: "Devoluciónes por verificar", color: "bg-blue-100 text-custom-blue" },
      { value: "en_zona_despacho", label: "En zona de despacho", color: "bg-sky-100 text-sky-800" },
      { value: "listo_para_despachar", label: "Listo para despachar", color: "bg-sky-100 text-sky-800" },
      { value: "guia_impresa", label: "Guía impresa", color: "bg-sky-100 text-sky-800" },
      { value: "manifiesto_impreso", label: "Manifiesto impreso", color: "bg-sky-100 text-sky-800" },
      { value: "devolucion_completada", label: "Devolución completada", color: "bg-green-100 text-green-800" },
    ];
 
    export const COTIZACION_STATES = [
      { value: "VIGENTE", label: "VIGENTE", color: "bg-yellow-100 text-yellow-800" }, // no mover de esta posicion
      { value: "APROBADA", label: "APROBADA", color: "bg-green-100 text-green-800" },
      { value: "VENCIDA", label: "VENCIDA", color: "bg-red-100 text-red-800" },
    ];


    export const expiration_limit = [
      { value: "5",  label: "5" },
      { value: "10", label: "10" },
      { value: "15", label: "15" },
      { value: "20", label: "20" },
      { value: "30", label: "30" },
    ];

    export const tiendas = [
      { value: "Artiq", label: "Artiq" },
      { value: "Baristico", label: "Baristico" },
      { value: "Bigcenter", label: "Bigcenter" },
      { value: "Distrito Cafetero", label: "Distrito Cafetero" },
      { value: "Exito", label: "Exito" },
      { value: "Falabella", label: "Falabella" },
      { value: "Homecenter", label: "Home Center" },
      { value: "Mercado Libre", label: "Mercado Libre" },
      { value: "Restaurante", label: "Restaurante" },
      { value: "Garantias", label: "Garantias" },
      { value: "mdm", label: "MDM" }
      
    ];

    export const STORE_STYLES = [
      {value:"Artiq", label: "Artiq", shortValue: "AR", color:"text-artiq font-semibold"},
      {value:"Bigcenter",  label: "Bigcenter",  shortValue: "BC",color:"text-bigcenter font-semibold" },
      {value:"Distrito Cafetero", label:"Distrito Cafetero", shortValue: "DC", color:"text-distrito font-semibold"},
      {value:"Falabella",  label: "Falabella",  shortValue: "FL", color:"text-falabella font-semibold"},
      {value:"Homecenter", label: "Homecenter", shortValue: "HC", color:"text-red font-semibold"},
      {value:"Mercado Libre", label:"Mercado Libre", shortValue: "ML", color:"text-mercadol font-semibold"},
      {value: "Garantias", label: "Garantías", shortValue: "GA", color:"text-green-600 font-semibold"},
      {value: "OFIMA", label: "OFIMA", shortValue: "OF", color:"text-blue-600 font-semibold"},
      {value: "Exito", label: "Exito", shortValue: "EX", color:"text-exito font-semibold"},
      {value: "Baristico", label: "Baristico", shortValue: "BR", color:"text-amber-700 font-semibold"},
      {value: "Restaurante", label: "Restaurante", shortValue: "RT", color:"text-teal-600 font-semibold"},
      {value: "Hexa", label: "Hexa", shortValue: "HX", color:"text-hexa font-semibold"}
    ];
    
    export const marcas = [
      { value: "",label: "seleccione una marca" },
      { value: "Artiq",label: "Artiq" },
      { value: "Barístico",label: "Barístico" },
      { value: "Bigcenter",label: "Bigcenter" },
      { value: "Cusiné",label: "Cusiné" },
      { value: "Distrito Cafetero",label: "Distrito Cafetero" },
      { value: "Mercado Libre", label: "Mercado Libre" },
      { value: "Exito", label: "Exito" },
      { value: "Falabella", label: "Falabella" },
      { value: "Homecenter", label: "Home Center" },
      { value: "mdm", label: "MDM" },
    ];
    
    export const destino_pedido = [
      { value: "metropolitana",label: "Area Metropolitana" },
      { value: "nacional",label: "Nacional" }
    ];

/** Códigos de lista de precio Ofima (CODPRECIO → codigoPrecio en API) */
export const ofimaCodigosPrecio = [
  { value: '001', label: 'Venta General' },
  { value: '010', label: 'Bigcenter' },
  { value: '009', label: 'Distrito' },
  { value: '002', label: 'Mercado Libre' },
  { value: '003', label: 'Falabella' },
  { value: '004', label: 'Homecenter' },
  { value: '007', label: 'Éxito' },
  { value: '008', label: 'Otro' }
];

export const tiposDeServicioLiquidacion = [
 {value: "3", label: "Mercancía Terrestre", description: "Supera los 9 Kg"},
 {value: "12", label: "Paquete Terrestre", description: "1 a 8 Kg"}
];